import { Check } from "@mui/icons-material";
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import React from "react";
import { pink } from "../../shared/colours";

const EmployeeCourseTable = (props) => {
	
	const handleEmployeeClick = (employee) => {
		props.onEmployeeClick(employee);
	};
	
	return (
		<Box sx={{width: "100%", margin: "auto"}}>
			<TableContainer component={Paper} sx={{ width: "100%" }}>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell sx={{ textAlign: "left" }}>Employee Name</TableCell>
							<TableCell sx={{ textAlign: "left" }}>Email</TableCell>
							<TableCell sx={{ textAlign: "center" }}>Course<br/>Started</TableCell>
							<TableCell sx={{ textAlign: "center" }}>Course<br/>Completed</TableCell>
							<TableCell sx={{ textAlign: "center" }}>Retries</TableCell>
							<TableCell sx={{ textAlign: "center" }}>Grade</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{props.employeeCourses? props.employeeCourses.map((employeeCourse) => {
							return (<TableRow
								key={`employeecourse_${employeeCourse.employee.id}`}
								sx={{ ":hover": { cursor: "pointer" } }}
								onClick={() => { handleEmployeeClick(employeeCourse.employee); }}
							>
								<TableCell sx={{ textAlign: "left" }}>
									{`${employeeCourse.employee.firstname} ${employeeCourse.employee.lastname}`}
								</TableCell>
								<TableCell sx={{ textAlign: "left" }}>
									{`${employeeCourse.employee.email}`}
								</TableCell>
								<TableCell sx={{ textAlign: "center" }}>
									{(employeeCourse.course.started)?
										<Check/>
										:
										<Typography sx={{ color: pink }}>{`-`}</Typography>
									}
								</TableCell>
								<TableCell sx={{ textAlign: "center" }}>
									{(employeeCourse.course.completed)?
										<Check/>
										:
										<Typography sx={{ color: pink }}>{`-`}</Typography>
									}
								</TableCell>
								<TableCell sx={{ textAlign: "center" }}>
									{`${employeeCourse.course.retries}`}
								</TableCell>
								<TableCell sx={{ textAlign: "center" }}>
									{`${employeeCourse.course.grade? employeeCourse.course.grade : "-"}`}
								</TableCell>
							</TableRow>);
						}):<React.Fragment/>}
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	);

}

export default EmployeeCourseTable;